import queryString from "query-string";
import axios from "axios";

import { API_ENDPOINT } from "utils/config";
import { Alert, Log } from "utils/services";
import { IApiResponse } from "models";

export const uploadPhoto = async (
  file: File
): Promise<{ documentId: number; filename: string; url: string } | undefined> => {
  let params = queryString.parse(window.location.search);
  const tenantGuid = params.tguid ?? "";
  // TODO: templateId will become a guid in a later phase.
  const templateId = params.rid ?? "";

  const filename = file.name;

  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("filename", filename);
    formData.append("imageType", "template");
    formData.append("tenantGuid", `${tenantGuid}`);

    const request = await axios.post<IApiResponse<TUploadPhoto[]>>(API_ENDPOINT.PHOTO, formData, {
      headers: {
        "X-Enable-Contractor-Features": "true",
      },
    });

    if (request.status === 200 && request.data.data && request.data.data.length > 0) {
      // remove the storagage token
      const photoUrl = request.data.data[0].url;
      const urlPars = photoUrl.split(filename);
      return {
        documentId: request.data.data[0].cloudId,
        filename,
        url: urlPars[0] + filename,
      };
    } else {
      Alert.simpleAlert({
        header: `Upload Error: ${request.status}`,
        message: `An unknown error occurred. ${request.data.message}`,
      });
    }
  } catch (ex) {
    Log.handleException(ex, {
      hint: {
        endpoint: "uploadPhoto()",
        params: { tenantGuid, templateId },
      },
      showAlert: true,
    });
  }

  return;
};

type TUploadPhoto = {
  cloudId: number;
  filename: string;
  success: boolean;
  url: string;
};
